import { render } from "./RemoveMenuModifier.vue?vue&type=template&id=76867600&scoped=true"
import script from "./RemoveMenuModifier.vue?vue&type=script&lang=js"
export * from "./RemoveMenuModifier.vue?vue&type=script&lang=js"

import "./RemoveMenuModifier.vue?vue&type=style&index=0&id=76867600&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76867600"]])

export default __exports__